import { TablePaginationConfig } from 'antd'
import { create } from 'zustand'

import { DEFAULT_PAGE_SIZE } from '@/constants'
import { NomenclatureEditorFeedProductInterface } from '@/types'

interface NomenclatureEditorFeedStateInterface {
  products: NomenclatureEditorFeedProductInterface[]
  productsLoading: boolean
  paginatedTableLoading: boolean
  pagination: TablePaginationConfig
  setProducts: (products: NomenclatureEditorFeedProductInterface[]) => void
  setProductsLoading: (productsLoading: boolean) => void
  setPagination: (pagination: TablePaginationConfig) => void
  setPaginatedTableLoading: (paginatedTableLoading: boolean) => void
  setInitialNomenclatureEditorFeedStore: () => void
}

const initialState = {
  products: [],
  productsLoading: false,
  paginatedTableLoading: false,
  pagination: { current: 0, pageSize: DEFAULT_PAGE_SIZE, total: 0 },
}

export const useNomenclatureEditorFeedStore =
  create<NomenclatureEditorFeedStateInterface>((set) => ({
    ...initialState,
    setProducts: (products: NomenclatureEditorFeedProductInterface[]) => {
      set({ products })
    },
    setProductsLoading: (productsLoading: boolean) => {
      set({ productsLoading })
    },
    setPagination: (pagination: TablePaginationConfig) => {
      set({ pagination })
    },
    setPaginatedTableLoading: (paginatedTableLoading: boolean) => {
      set({ paginatedTableLoading })
    },
    setInitialNomenclatureEditorFeedStore: () => set({ ...initialState }),
  }))
